import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export function WhatYouGet() {
  const items = [{
    text: 'La Guía Maestra "Despertar Sin Dolor" con el paso a paso detallado.',
    value: '$29'
  }, {
    text: 'El Protocolo LSA de 10 minutos ilustrado para hacer en la cama.',
    value: '$19'
  }, {
    text: 'La receta del "Agua de Oro": el hidratante anti-oxidante que desinflama tus tejidos.',
    value: '$15'
  }, {
    text: 'El Plan de Rescate de 21 días para monitorear tu progreso.',
    value: '$12'
  }, {
    text: 'Checklist de Higiene de Sueño para evitar despertarte "encogido".',
    value: '$9'
  }];
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <FadeIn data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-black mb-12 text-center text-stone-900" data-id="element-202">
            Lo que obtienes hoy
          </h2>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-stone-200" data-id="element-203">
            <ul className="space-y-6 mb-12" data-id="element-204">
              {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-205">
                  <li className="flex items-start justify-between gap-4 border-b border-stone-100 pb-4 last:border-0 last:pb-0" data-id="element-206">
                    <div className="flex items-start gap-4" data-id="element-207">
                      <CheckCircle2 className="w-6 h-6 md:w-8 md:h-8 text-amber-600 flex-shrink-0 mt-1" data-id="element-208" />
                      <span className="text-lg md:text-xl text-stone-700 font-medium leading-relaxed" data-id="element-209">
                        {item.text}
                      </span>
                    </div>
                    <span className="text-stone-400 font-bold whitespace-nowrap hidden md:block" data-id="element-210">
                      Valor: {item.value}
                    </span>
                  </li>
                </FadeIn>)}
            </ul>

            <div className="bg-stone-50 p-8 rounded-2xl border border-stone-200 text-center" data-id="element-211">
              <p className="text-xl text-stone-500 mb-2 font-medium" data-id="element-212">
                Valor total: <span className="line-through" data-id="element-213">$84</span>
              </p>
              <p className="text-3xl md:text-4xl font-black text-stone-900 mb-8" data-id="element-214">
                Hoy todo por solo <span className="text-amber-600" data-id="element-215">$6.39</span>
              </p>
              <Button scrollTo="pricing" href="https://guiasparavivir.com/cart/52440554701089:1" fullWidth data-id="element-216">
                ¡Sí! Quiero Despertar Sin Dolor
              </Button>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}